/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNotificationsBody
 */
export interface UpdateNotificationsBody {
    /**
     * Master marketing switch. False silences marketing on every channel.
     * @type {boolean}
     * @memberof UpdateNotificationsBody
     */
    notificationMarketing: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationsBody
     */
    notificationMenuOrderStatus: boolean;
    /**
     * Narrows the master switch to email. Omitted leaves the stored value untouched; it is not the same as sending false.
     * @type {boolean}
     * @memberof UpdateNotificationsBody
     */
    notificationMarketingEmail?: boolean;
    /**
     * Narrows the master switch to Discord DMs.
     * @type {boolean}
     * @memberof UpdateNotificationsBody
     */
    notificationMarketingDiscord?: boolean;
    /**
     * Narrows the master switch to in-app toasts and in-game overlays together.
     * @type {boolean}
     * @memberof UpdateNotificationsBody
     */
    notificationMarketingInApp?: boolean;
}

/**
 * Check if a given object implements the UpdateNotificationsBody interface.
 */
export function instanceOfUpdateNotificationsBody(value: object): value is UpdateNotificationsBody {
    if (!('notificationMarketing' in value) || value['notificationMarketing'] === undefined) return false;
    if (!('notificationMenuOrderStatus' in value) || value['notificationMenuOrderStatus'] === undefined) return false;
    return true;
}

export function UpdateNotificationsBodyFromJSON(json: any): UpdateNotificationsBody {
    return UpdateNotificationsBodyFromJSONTyped(json, false);
}

export function UpdateNotificationsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNotificationsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationMarketing': json['notificationMarketing'],
        'notificationMenuOrderStatus': json['notificationMenuOrderStatus'],
        'notificationMarketingEmail': json['notificationMarketingEmail'] == null ? undefined : json['notificationMarketingEmail'],
        'notificationMarketingDiscord': json['notificationMarketingDiscord'] == null ? undefined : json['notificationMarketingDiscord'],
        'notificationMarketingInApp': json['notificationMarketingInApp'] == null ? undefined : json['notificationMarketingInApp'],
    };
}

export function UpdateNotificationsBodyToJSON(json: any): UpdateNotificationsBody {
    return UpdateNotificationsBodyToJSONTyped(json, false);
}

export function UpdateNotificationsBodyToJSONTyped(value?: UpdateNotificationsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notificationMarketing': value['notificationMarketing'],
        'notificationMenuOrderStatus': value['notificationMenuOrderStatus'],
        'notificationMarketingEmail': value['notificationMarketingEmail'],
        'notificationMarketingDiscord': value['notificationMarketingDiscord'],
        'notificationMarketingInApp': value['notificationMarketingInApp'],
    };
}

